import { cookiePrivacyPolicyPopupStyles as styles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";

styles.drawer = {
    ...styles.drawer,
    isAutoSize: false,
};
